var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9834 43.4403H74.4691V31.0288C74.4691 24.1831 80.0348 18.6173 86.8806 18.6173H88.432C91.0113 18.6173 93.0863 16.5422 93.0863 13.9629V4.65432C93.0863 2.07505 91.0113 0 88.432 0H86.8806C69.7372 0 55.8518 13.8854 55.8518 31.0288V77.5719C55.8518 82.7111 60.0213 86.8806 65.1604 86.8806H89.9834C95.1226 86.8806 99.2921 82.7111 99.2921 77.5719V52.7489C99.2921 47.6098 95.1226 43.4403 89.9834 43.4403ZM34.1317 43.4403H18.6173V31.0288C18.6173 24.1831 24.1831 18.6173 31.0288 18.6173H32.5802C35.1595 18.6173 37.2345 16.5422 37.2345 13.9629V4.65432C37.2345 2.07505 35.1595 0 32.5802 0H31.0288C13.8854 0 0 13.8854 0 31.0288V77.5719C0 82.7111 4.16949 86.8806 9.30863 86.8806H34.1317C39.2708 86.8806 43.4403 82.7111 43.4403 77.5719V52.7489C43.4403 47.6098 39.2708 43.4403 34.1317 43.4403Z",
    fill: "#0B7132",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesIcon);
export default __webpack_public_path__ + "static/media/quotes_icon.eeb45925b1456788d14e19d988dd5621.svg";
export { ForwardRef as ReactComponent };